import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../../shared/service/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-issue-detail-dialog',
  templateUrl: './issue-detail-dialog.component.html',
  styleUrls: ['./issue-detail-dialog.component.scss']
})
export class IssueDetailDialogComponent implements OnInit {

  agendaID: string;
  isShow: boolean = false;
  loginUser:object = null;
  isOpenInNewTab: boolean = false;
  constructor(
    private loginService: LoginService,
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  showDialog(agenda_id:string, openNewTab: boolean = false){
    this.loginUser = JSON.parse(sessionStorage.getItem('loginUserInformation'));
    this.isOpenInNewTab = openNewTab;
    this.agendaID = agenda_id;
    this.isShow = true;
  }

  loginToC301(){
    const path = 'pages/platform/c301/'+this.agendaID;
    if(this.isOpenInNewTab){
      this.loginService.loginToNewTab(path);
    }else{
      this.loginService.loginToPage(path);
    }
  }

    /**
  * move to a201
  */
    public moveA201(): void {
      // 入会申請(A201)へ遷移
      this.router.navigate(
        ['pages/platform/a201/new'],
        {
          queryParams: { screenId: 'a201' },
        }
      );
    }
}
